import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/app.css";
import SessionProvider from "./auth/SessionProvider";
import AppRoutes from "./app/AppRoutes";
createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <SessionProvider>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={4000} />
    </SessionProvider>
  </BrowserRouter>
);
